import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-bui-load-more-button',
  templateUrl: './bui-load-more-button.component.html',
  styleUrls: ['./bui-load-more-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuiLoadMoreButtonComponent {
  @Input() textAlign: 'left' | 'center' | 'right' = 'center';
  @Input() disabled = false;
  @Output() clickEvent: EventEmitter<any> = new EventEmitter<any>();

  onClick(event: any): void {
    if (!this.disabled) {
      this.clickEvent.emit(event);
    }
  }
}
